const INITIAL_STATE = {
  tryRedirect: false,
  showFilters: true
};

const SearchFacilityData = {
  INITIAL_STATE,
}

export default SearchFacilityData;